import { render, staticRenderFns } from "./IndexPageSpecialListSection.vue?vue&type=template&id=26c00966&"
import script from "./IndexPageSpecialListSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageSpecialListSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports